import { useEffect } from 'react';
import { initSmoothScroll, destroySmoothScroll } from '../utils/smoothScroll';
import { initScrollToTop } from '../utils/scrollToTop';

export const useSmoothScroll = () => {
  useEffect(() => {
    initSmoothScroll();
    const cleanup = initScrollToTop();
    
    return () => {
      destroySmoothScroll();
      if (cleanup) {
        cleanup();
      }
    };
  }, []);
};

